<template>
  <v-container fluid>
    <v-layout row wrap>
      <!-- Create Button -->
      <!-- <v-tooltip top>
        <v-btn
          slot="activator"
          color="primary"
          dark
          fixed
          bottom
          right
          fab
          @click="onHandleDialog(true, 'create', null)"
        >
          <v-icon>fa-plus</v-icon>
        </v-btn>
        <span>{{$t('create')}}</span>
      </v-tooltip>-->
      <v-flex md12 sm12 xs12 ma-2>
        <v-layout row wrap>
          <!-- list date -->
          <v-flex md5 sm12 xs12 px-2>
            <template>
              <v-layout row>
                <v-flex
                  md12
                  sm12
                  xs12
                  px-2
                  scrollable
                  class="scroll-y"
                  style="max-height: 760px;margin-top:5px;"
                >
                  <!-- <v-card scrollable class="scroll-y" style="max-height: 760px;margin-top:5px;"> -->
                  <v-list
                    two-line
                    subheader
                    v-for="(item, index) in Holidaylist"
                    :key="index"
                    avatar
                    @click="''"
                  >
                    <v-subheader v-if=" item.holidayitems.length > 0 ">{{$t("month."+item.name)}}</v-subheader>
                    <v-list-tile
                      v-for="(holiday, index) in item.holidayitems"
                      :key="index"
                      avatar
                      @click="''"
                    >
                      <v-list-tile-avatar>
                        <v-icon color="light-blue darken-3">fa-calendar-alt</v-icon>
                      </v-list-tile-avatar>

                      <v-list-tile-content>
                        <v-list-tile-title>{{ holiday.holidayname }}</v-list-tile-title>
                        <v-list-tile-sub-title
                          v-if="holiday.startDate==holiday.endDate"
                        >{{selectedformatDate(holiday.startDate)}}</v-list-tile-sub-title>
                        <v-list-tile-sub-title
                          v-if="holiday.startDate!=holiday.endDate"
                        >{{selectedformatDate(holiday.startDate)}} - {{selectedformatDate(holiday.endDate)}}</v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-btn icon ripple>
                          <v-icon color="amber accent-4" @click="onEdit(holiday)">edit</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-action>
                        <v-btn icon ripple>
                          <v-icon color="deep-orange accent-4" @click="deleteItem(holiday)">delete</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider v-if=" item.holidayitems.length > 0 "></v-divider>
                  </v-list>
                  <!-- </v-card> -->
                </v-flex>
              </v-layout>
            </template>
            <v-flex md12 sm12 xs12 text-xs-right style="margin-top:5px;">
              <!-- <v-btn slot="activator" color="warning" dark @click="importdialog=true">
                <v-icon>save_alt</v-icon>&nbsp;&nbsp;
                <span>{{$t('ImportFile')}}</span>
              </v-btn> -->
              <v-btn slot="activator" color="green accent-4" dark @click="dialog=true">
                <v-icon>fa-plus</v-icon>&nbsp;&nbsp;
                <span>{{$t('create')}}</span>
              </v-btn>
            </v-flex>
          </v-flex>
          <!-- calendar -->
          <v-flex md7 sm12 xs12 text-xs-center class="hidden-xs-only">
            <v-layout row wrap v-for="(item, index) in monthlist" :key="index">
              <v-flex md6 sm6 xs6 px-2 v-for="(i, index) in item.monthitems" :key="index">
                <v-date-picker
                  v-if="item.No == numberbutton"
                  v-model="i.month"
                  :events="arrayEvents"
                  event-color="red accent-4"
                  width="100%"
                  height="50%"
                  disabled
                  style="margin:5px;"
                ></v-date-picker>
              </v-flex>
            </v-layout>
            <v-flex md12 sm12 xs12 text-xs-right style="margin:5px;">
              <v-btn @click="onprev()">
                <v-icon dark left>keyboard_arrow_left</v-icon>
                {{$t('LastMount')}}
              </v-btn>
              <v-btn @click="onnext()">
                {{$t('NextMount')}}
                <v-icon right dark>keyboard_arrow_right</v-icon>
              </v-btn>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-flex md12 sm12 xs12>
      <!-- <frm-dialog :json_data="dialog_data" v-on:close-dialog="onCloseDialog" /> -->

      <!-- create holiday -->
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">{{$t('AddHoliday')}}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md6>
                    <v-menu
                      v-model="createstart_date"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template slot="activator">
                        <v-text-field
                          v-model="form_date.startDate"
                          :label="$t('fromdate')"
                          prepend-icon="event"
                          readonly
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="form_date.startDate" :rules="form_rules.startDate"></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-menu
                      v-model="createend_date"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template slot="activator">
                        <v-text-field
                          v-model="form_date.endDate"
                          :label="$t('todate')"
                          prepend-icon="event"
                          readonly
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="form_date.endDate" :rules="form_rules.endDate"></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      prepend-icon="info"
                      :label="$t('detail')"
                      v-model="form_date.holidayname"
                      :rules="form_rules.holidayname"
                      hide-details
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>
              <v-btn color="blue darken-1" flat @click="inputholiday()">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <!-- edit holiday -->
      <v-layout row justify-center>
        <v-dialog v-model="Editdialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">{{$t('EditHoliday')}}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md6>
                    <v-menu
                      v-model="editstart_date"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template slot="activator">
                        <v-text-field
                          v-model="update_dialog_data.startDate"
                          :label="$t('fromdate')"
                          prepend-icon="event"
                          readonly
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="update_dialog_data.startDate"
                        :rules="form_rules.startDate"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-menu
                      v-model="editend_date"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template slot="activator">
                        <v-text-field
                          v-model="update_dialog_data.endDate"
                          :label="$t('todate')"
                          prepend-icon="event"
                          readonly
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="update_dialog_data.endDate"
                        :rules="form_rules.endDate"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      prepend-icon="info"
                      :label="$t('detail')"
                      v-model="update_dialog_data.holidayname"
                      :rules="form_rules.holidayname"
                      hide-details
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="Editdialog = false">Close</v-btn>
              <v-btn color="blue darken-1" flat @click="onUpdate()">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <!-- import holiday -->
      <!-- <v-layout justify-center>
        <v-dialog v-model="importdialog" width="600px">
          <v-card>
            <v-card-title>
              <span class="headline" app fixed>Use Google's location service?</span>
            </v-card-title>
            <v-card-text>
              <template>
                <v-layout row>
                  <v-flex
                    md12
                    sm12
                    xs12
                    px-2
                    scrollable
                    class="scroll-y"
                    style="max-height:500px;margin-top:5px;"
                  >
                  
                    <v-list
                      two-line
                      subheader
                      v-for="(item, index) in Holidaylist"
                      :key="index"
                      avatar
                      @click="''"
                    >
                      <v-subheader v-if=" item.holidayitems.length > 0 ">{{$t("month."+item.name)}}</v-subheader>
                      <v-list-tile
                        v-for="(holiday, index) in item.holidayitems"
                        :key="index"
                        avatar
                        @click="''"
                      >
                        <v-list-tile-avatar>
                          <v-icon color="light-blue darken-3">fa-calendar-alt</v-icon>
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                          <v-list-tile-title>{{ holiday.holidayname }}</v-list-tile-title>
                          <v-list-tile-sub-title
                            v-if="holiday.startDate==holiday.endDate"
                          >{{selectedformatDate(holiday.startDate)}}</v-list-tile-sub-title>
                          <v-list-tile-sub-title
                            v-if="holiday.startDate!=holiday.endDate"
                          >{{selectedformatDate(holiday.startDate)}} - {{selectedformatDate(holiday.endDate)}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-btn icon ripple>
                            <v-icon color="amber accent-4" @click="onEdit(holiday)">edit</v-icon>
                          </v-btn>
                        </v-list-tile-action>
                        <v-list-tile-action>
                          <v-btn icon ripple>
                            <v-icon color="deep-orange accent-4" @click="deleteItem(holiday)">delete</v-icon>
                          </v-btn>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-divider v-if=" item.holidayitems.length > 0 "></v-divider>
                    </v-list>
                  </v-flex>
                </v-layout>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="importdialog = false">Disagree</v-btn>
              <v-btn color="green darken-1" text @click="importdialog = false">Agree</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout> -->
    </v-flex>
    <!-- Delete Dialog -->
    <v-flex md12 sm12 xs12>
      <delete-dialog
        :json_data="delete_dialog_data"
        v-on:close-dialog="onCloseDeleteDialog"
        v-on:delete-item="onDelete"
      />
    </v-flex>
    <!-- Snackbar -->
    <v-snackbar v-model="snack_model.status" :timeout="3500" :top="'top'" :color="snack_model.type">
      {{ snack_model.msg }}
      <v-btn dark flat icon @click="snack_model.status = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import DocumentService from "@/services/DocumentService";
import ProcessService from "@/services/ProcessService";
import SettingService from "@/services/SettingService";
import Empimage from "../../components/getempimage.vue";
import DeleteDialog from "../../components/master/dialogs/DeleteDialog";
import FrmDialog from "./FormDialog";
import Utils from "@/utils/";
import XLSX from "xlsx";
import moment from "moment";
import { constants } from "crypto";

export default {
  data: () => ({
    form_date: {
      startDate: "",
      endDate: "",
      holidayname: ""
    },
    form_rules: {
      startDate: [v => !!v || "do not empty."],
      endDate: [v => !!v || "do not empty."],
      holidayname: [v => !!v || "do not empty."]
    },
    createstart_date: false,
    createend_date: false,
    editstart_date: false,
    editend_date: false,
    arrayEvents: [],
    monthlist: [
      {
        No: 1,
        monthitems: []
      },
      {
        No: 2,
        monthitems: []
      },
      {
        No: 3,
        monthitems: []
      }
    ],
    Holidaylist: [
      { No: 1, name: "January", holidayitems: [] },
      { No: 2, name: "February", holidayitems: [] },
      { No: 3, name: "March", holidayitems: [] },
      { No: 4, name: "April", holidayitems: [] },
      { No: 5, name: "May", holidayitems: [] },
      { No: 6, name: "June", holidayitems: [] },
      { No: 7, name: "July", holidayitems: [] },
      { No: 8, name: "August", holidayitems: [] },
      { No: 9, name: "September", holidayitems: [] },
      { No: 10, name: "October", holidayitems: [] },
      { No: 11, name: "November", holidayitems: [] },
      { No: 12, name: "December", holidayitems: [] }
    ],
    listholiday: [],
    numberbutton: 1,
    dialog_data: {
      status: false,
      save_type: String,
      data: Object
    },
    delete_dialog_data: {
      status: false
    },
    update_dialog_data: {
      roworder: 0,
      startDate: "",
      endDate: "",
      holidayname: ""
    },
    snackbarcolor: "red",
    calendarDialog: false,
    dialog: false,
    Editdialog: false,
    importdialog: false,
    emp_code: "",
    filterDialog: false,
    table_datalist: [],
    table_head_model: {
      ชื่อ: "1",
      date: []
    },
    head_date: [],
    json_fields: {
      ชื่อ: "name",
      date: []
    },
    selectitems: [
      { txt: "None", val: "" },
      { txt: "ThisMount", val: 0 },
      { txt: "ThisWeek", val: 1 },
      { txt: "Today", val: 2 },
      { txt: "LastWeek", val: 3 },
      { txt: "LastMount", val: 4 }
    ],
    ChoiceSelected: "",
    json_data: [],
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8"
        }
      ]
    ],
    buttonlist: 1,
    pageActive: 1,
    delDialogStatus: false,
    delDialog: {
      roworder: "",
      name: "",
      emp_code: "",
      date: ""
    },
    snackbar: false,
    snackmsg: "",
    snack_type: "",
    user_datafinger: [],
    time: [],
    datacheckin: [],
    branch_Select: "",
    department_Select: "",
    from_date: "",
    to_date: "",
    monthname: "",
    month: 0,
    year: "",
    roworder: 0,
    canLoadMore: true,
    snack_model: {
      status: "",
      msg: "",
      type: ""
    }
  }),
  created: async function() {
    this.setShowFilter({
      status: 0
    });
    this.commitSetToolbar({
      patternTool: "0"
    });
    this.$store.watch(
      state => {
        state.filter.SelectBranch;
        state.filter.SelectDepartment;
        state.filter.SelectPosition;
        state.filter.SearchData;
        state.filter.FromDate;
        state.filter.ToDate;
      },
      () => {},
      {
        deep: true
      }
    );
    await this.getHolidayList();
    //await this.setholiday();
    await this.selectedformatMonth();
    //await this.selectedHoliday();
  },
  destroyed: function() {
    this.commitToggleAlertDialog({
      status: false,
      message: Object
    });
  },
  components: {
    Empimage,
    FrmDialog,
    DeleteDialog
  },
  computed: {
    ...mapState("filter", [
      "Branch_List",
      "Department_List",
      "Position_List",
      "Errormsg",
      "SelectBranch",
      "SelectDepartment",
      "FromDate",
      "ToDate",
      "SearchData"
    ]),
    ...mapState("app", ["showLoading"]),
    branchSelect: {
      get() {
        return this.SelectBranch;
      },
      async set(value) {
        await this.getDepartment({ branch: value });
      }
    },
    departmentSelect: {
      get() {
        return this.SelectDepartment;
      },
      async set(value) {
        await this.getPosition({ department: value });
      }
    }
  },
  methods: {
    ...mapMutations("filter", [
      "setShowFilter",
      "selectedFormDate",
      "selectedToDate",
      "getAllEmployeeByBranch",
      "selectedPosition"
    ]),
    ...mapActions("filter", ["getBranch", "getDepartment", "getPosition"]),
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    onCloseDialog() {
      this.dialog_data.status = false;
      //this.getExpensesList();
    },
    onCloseDeleteDialog() {
      this.delete_dialog_data.status = false;
    },
    inputholiday() {
      var start = +new Date(this.form_date.startDate);
      var end = +new Date(this.form_date.endDate);
      console.log("start", start);
      console.log("end", this.form_date);
      if (this.form_date.startDate == "" || this.form_date.endDate == "") {
        this.showSnackBar("กรุณากรอกจากวันที่ ถึงวันที่", "error");
      } else if (this.form_date.holidayname == "") {
        this.showSnackBar("กรุณากรอกรายละเอียด", "error");
      } else if (start > end) {
        this.showSnackBar(
          "กรุณากรอกจากวันที่ให้น้อยกว่าหรือเท่ากับถึงวันที่",
          "error"
        );
      } else {
        this.listholiday.push(this.form_date);
        SettingService.createHolidayList(this.form_date)
          .then(res => {
            console.log(this.listholiday);
            this.setholiday();
            this.selectedHoliday();
            console.log(this.form_date);
            this.showSnackBar("บันทึกสำเร็จ", "success");
            this.dialog = false;
            this.clearForm();
          })
          .catch(err => {
            this.showSnackBar(err.response.data, "error");
          });

        // console.log(this.listholiday)
        // this.setholiday();
        // //this.selectedformatMonth();
        // this.selectedHoliday();
        // console.log(this.form_date)
        //  this.showSnackBar('บันทึกสำเร็จ', 'success');
        // this.dialog = false;
      }
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    onHandleDialog(status, save_type, data) {
      this.dialog_data = {
        status: status,
        save_type: save_type,
        data: data
      };
    },
    setholiday() {
      this.arrayEvents = [];
      this.listholiday.forEach(date => {
        if (date.startDate == date.endDate) {
          this.arrayEvents.push(date.startDate);
          //console.log("=== :", date.startDate);
        } else if (date.startDate != date.endDate) {
          var start = new Date(date.startDate);
          var end = new Date(date.endDate);
          for (var d = start; d <= end; d.setDate(d.getDate() + 1)) {
            this.arrayEvents.push(this.selectedformatDates(d));
            //console.log(this.selectedformatDates(d));
          }
        }
      });
    },
    selectedHoliday() {
      this.Holidaylist.forEach(list => {
        list.holidayitems = [];
        this.listholiday.forEach(holiday => {
          var d = new Date(holiday.startDate);
          var month = d.getMonth() + 1;
          if (list.No == month) {
            list.holidayitems.push(holiday);
          }
        });
      });
      //console.log(this.Holidaylist);
    },
    selectedformatMonth() {
      var d = new Date(),
        year = d.getFullYear();
      var months = "";
      var id = 1;
      var num = 0;
      var no = 0;
      for (let index = 1; index <= 12; index++) {
        if (num == 4) {
          id = id + 1;
          no = no + 1;
          num = 0;
          console.log("id: ",id);
          console.log("no: ",no);
          console.log("num: ",num);
        } else if (this.monthlist[no].No == id && num != 4) {
          id = id;
        }
        if (index < 10) {
          months = "" + year + "-0" + index;
          this.monthlist[no].monthitems.push({ month: months });
        } else {
          months = "" + year + "-" + index;
          this.monthlist[no].monthitems.push({ month: months });
        }
        num = num + 1;
      }
      
      // console.log(this.monthlist);
    },

    onprev() {
      if (this.numberbutton != 1) {
        this.numberbutton = this.numberbutton - 1;
      } else {
        this.numberbutton = this.numberbutton;
      }
      //console.log(this.numberbutton);
    },
    onnext() {
      if (this.numberbutton != 3) {
        this.numberbutton = this.numberbutton + 1;
      } else {
        this.numberbutton = this.numberbutton;
      }
      //console.log(this.numberbutton);
    },
    onEdit(detail) {
      this.Editdialog = true;
      console.log("detail", detail);
      this.update_dialog_data.startDate = detail.startDate;
      this.update_dialog_data.endDate = detail.endDate;
      this.update_dialog_data.holidayname = detail.holidayname;
      this.update_dialog_data.roworder = detail.roworder;
      console.log(detail);
    },
    onUpdate() {
      // this.update_dialog_data.startDate= this.form_date.startDate;
      // this.update_dialog_data.enddate = this.form_date.endDate;
      // this.update_dialog_data.holidayname = this.form_date.holidayname;
      //  this.update_dialog_data.roworder =  this.roworder
      console.log(this.update_dialog_data);
      SettingService.updateHolidayList(this.update_dialog_data)
        .then(res => {
          this.showSnackBar("update success", "success");
          this.Editdialog = false;
          this.getHolidayList();
        })
        .catch(err => {
          this.showSnackBar(err.response.data, "error");
        });
    },
    getHolidayList() {
      this.listholiday = [];
      SettingService.getHolidayList()
        .then(res => {
          if (res.data.content.length > 0) {
            res.data.content.forEach(data => {
              this.listholiday.push({
                roworder: data.roworder,
                startDate: data.startDate,
                endDate: data.endDate,
                holidayname: data.holidayname
              });
            });
          } else {
            this.canLoadMore = false;
          }
          this.setholiday();
          // this.selectedformatMonth();
          this.selectedHoliday();
          console.log(res.data.content);
          console.log(this.listholiday);
          console.log(this.Holidaylist);
        })
        .catch(err => {
          console.log(err);
        });
    },

    deleteItem(data) {
      this.delete_dialog_data.status = true;
      let message =
        "<p>" + this.$t("question.delete") + " " + data.holidayname + "?</p>";
      this.delete_dialog_data.message = message;
      this.delete_dialog_data.roworder = data.roworder;
      console.log(data);
    },
    onDelete() {
      SettingService.deleteHolidayList(this.delete_dialog_data.roworder)
        .then(res => {
          this.showSnackBar(this.$t("message.delete"), "success");
          this.pageActive = 1;
          this.table_data = [];
          this.getHolidayList();
          this.delete_dialog_data.status = false;
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        });
    },
    clearForm() {
      this.form_date = {
        startDate: "",
        endDate: "",
        holidayname: ""
      };
    },
    _today() {
      var d = new Date();

      var month = d.getMonth() + 1;
      var day = d.getDate();

      var output =
        d.getFullYear() +
        "-" +
        (month < 10 ? "0" : "") +
        month +
        "-" +
        (day < 10 ? "0" : "") +
        day;

      return output;
    },
    viewcalendar(code) {
      var date = "";
      this.calendarDialog = true;
      this.time = [];
      this.table_datalist.forEach(user_finger => {
        if (code == user_finger.code) {
          console.log(user_finger);
          user_finger.processTimes.forEach(element => {
            this.time.push(element);
          });
          console.log("time", this.time);
        }
      });
    },
    showCreateDocDialog() {
      if (
        this.FromDate == "" ||
        this.FromDate == undefined ||
        (this.ToDate == "" || this.FromDate == undefined) ||
        this.SelectBranch == ""
      ) {
        this.snackbar = true;
        this.snackmsg = "กรุณาเลือกสาขาจากวันที่ถึงวันที่";
      } else {
        this.payroll_doc.doc_no = this._docno("PR") + this._docdate();
        this.payroll_doc.begin_date = this.FromDate;
        this.payroll_doc.end_date = this.ToDate;
        this.docDialog = true;
      }
    },
    _docno(head) {
      return (
        head +
        "-xxx".replace(/[xy]/g, function(c) {
          var r = (Math.random() * 8) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        })
      );
    },
    _docdate() {
      var d = new Date();

      var month = d.getMonth() + 1;
      var day = d.getDate();
      var hour = d.getHours();
      var min = d.getMinutes();

      var output =
        d.getFullYear() +
        "" +
        (month < 10 ? "0" : "") +
        month +
        "" +
        (day < 10 ? "0" : "") +
        day +
        hour +
        min;

      return output;
    },
    selectedformatDate(date, format) {
      let lang = localStorage.lang;
      let v = this;
      var Days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      var months = [
        "Jan.",
        "Feb.",
        "Mar.",
        "Apr.",
        "May.",
        "Jun.",
        "Jul.",
        "Aug.",
        "Sep.",
        "Oct.",
        "Nov.",
        "Dec."
      ];
      var DaysTH = ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."];
      var monthsTH = [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค."
      ];

      var d = new Date(date),
        month = "" + d.getMonth(),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        days = d.getDay();
      if (lang == "en") {
        return [Days[days], day, months[month], year].join(" ");
      } else {
        return [DaysTH[days], day, monthsTH[month], year + 543].join(" ");
      }
    },
    selectedformatDates(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    process() {
      if (this.from_date == "" || this.to_date == "") {
        this.snackbar = true;
        this.snackmsg = "กรุณาเลือกวันที่";
      } else if (this.branchSelect == "All") {
        this.snackbar = true;
        this.snackmsg = "กรุณาเลือกสาขา";
      } else {
        this.table_head_model.date = [];
        this.head_date = [];
        var start = new Date(this.from_date);
        var end = new Date(this.to_date);

        for (var d = start; d <= end; d.setDate(d.getDate() + 1)) {
          //console.log(this.selectedformatDates(d))
          this.table_head_model.date.push(this.selectedformatDate(d));
          this.head_date.push(this.selectedformatDates(d));
          //console.log(this.table_head_model.date);
        }

        this.commitSetShowLoading(true);
        let searchVal = "";
        if (this.SearchData == undefined) {
          searchVal = "";
        } else {
          searchVal = this.SearchData;
        }

        if (this.departmentSelect == "All") {
          this.branch_Select = this.branchSelect;
          this.department_Select = "";
        } else {
          this.branch_Select = this.branchSelect;
          this.department_Select = this.departmentSelect;
        }
        DocumentService.getTimeChecklist(
          this.branch_Select,
          this.department_Select,
          this.emp_code,
          this.from_date,
          this.to_date
        ).then(res => {
          this.datacheckin = res.data;
          console.log(this.datacheckin);
          this.commitSetShowLoading(false);
          this.setShowDetail(this.datacheckin);
          this.table_datalist = [];
          this.datacheckin.forEach(element => {
            if (element.processTimes.length > 0) {
              this.table_datalist.push(element);
            }
          });

          console.log("gggg", this.table_datalist);
        });
        // console.log(this.datacheckin);
      }
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    timeformat(date) {
      return moment(date).format("HH:mm");
    },
    formatNumber(value, digit, hasComma) {
      return Utils.formatNumber(value, digit, hasComma);
    },
    formatDate(newDate, format_type) {
      return Utils.formatDate(newDate, format_type);
    },
    doCopyTable() {
      let el = document.getElementById("table_detail");
      let body = document.body;
      let range;
      let sel;
      if (document.createRange && window.getSelection) {
        range = document.createRange();
        sel = window.getSelection();
        sel.removeAllRanges();
        try {
          range.selectNodeContents(el);
          sel.addRange(range);
        } catch (e) {
          range.selectNode(el);
          sel.addRange(range);
        }
      }
      document.execCommand("Copy");
      alert("Copy Table to Clipboard");
    },
    printTable() {
      window.print();
    },
    getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then(res => {
          this.branch_items = res.data.content;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getProfileDepartmentList() {
      SettingService.getProfileDepartmentList()
        .then(res => {
          this.department_items = res.data.content;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // deleteItem(data) {
    //   this.delDialog.roworder = data.roworder;
    //   this.delDialog.name = data.name;
    //   this.delDialog.emp_code = data.firstName + " " + data.lastName;
    //   this.delDialog.date = data.add_date;
    //   this.delDialogStatus = true;
    // },
    // onDelete() {
    //   DocumentService.deleteExpenses(this.delDialog.roworder)
    //     .then(res => {
    //       this.delDialogStatus = false;
    //     })
    //     .catch(err => {
    //       this.commitToggleAlertDialog({
    //         status: true,
    //         message: err.response.data
    //       });
    //     });
    // },
    checkbutton(buttonlist) {
      if (buttonlist == 1) {
        this.buttonlist = 1;
        console.log("table");
      } else {
        this.buttonlist = 0;
        console.log("list");
      }
    },
    todaybutton() {
      var curr = new Date();
      this.from_date = this.selectedformatDates(curr);
      this.to_date = this.selectedformatDates(curr);
      this.process();
    }
  }
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Prompt");

h2,
span,
p {
  font-family: "Prompt", sans-serif;
}
.border {
  border: 1px black solid;
}
.scroll-area {
  position: relative;
  width: 100%;
  height: 440px;
  margin-bottom: 30px;
}

/* mobile  ----------- */
@media screen and (min-width: 320px) and (max-width: 640px) {
  #header_message {
    visibility: hidden;
    clear: both;
    float: left;
    width: 28%;
    display: none;
    margin-right: 0px !important;
  }
  .container-fluid {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .display_none1 {
    display: none;
  }
}

/* tablet  ----------- */
@media screen and (max-width: 3000px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
}

/* ipad pro  ----------- */
@media screen and (min-width: 1024px) and (max-width: 1366px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
}

@media screen and (min-width: 1024px) and (max-width: 3000px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}

/* iPads (landscape) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1020px) and (orientation: landscape) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
/* iPads (portrait) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
@media only screen and (min-device-width: 772px) and (max-device-width: 1020px) and (orientation: portrait) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
.button-wrapper {
  position: relative;
  width: 150px;
  text-align: center;
  margin-top: 5px;
  margin-right: 15px;
  margin-bottom: 5px;
}

.button-wrapper span.label {
  position: relative;
  display: inline-block;
  width: 100%;
  background: #00bfff;
  cursor: pointer;
  color: #fff;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 12px;
  box-shadow: 0px 2px 2px grey;
}
#file {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
</style>